<template>
    <Split v-model="pageSplit" class="layout">
        <div slot="left" style="padding:5px 10px;height: 100%;overflow:auto;">
            <div class="layout-title">
                <div class="layout-title-left">
                    菜单导航
                </div>
                <div class="layout-title-right">
                </div>
            </div>

            <Tree :data="treeData"
                  ref="menuTree"
                  style="margin: 20px 10px;"
                  @on-select-change="clickNode">
            </Tree>
        </div>
        <div slot="right" style="padding:10px;">
            <div class="layout-title">
                <div class="layout-title-left">
                    <img src="/static/imgs/kuaijiegongneng.png" class="jxyd-imgicon"/>
                    功能项列表
                </div>
                <div class="layout-title-right">
                    <Button type="dashed" title="新建功能项" @click="addFunction" style="margin-right:10px;" v-show="isAdd">
                        <Icon type="ios-add-circle-outline" size='18'/> 新建
                    </Button>
                    <Button type="error" title="删除功能项" @click="deleteFunction">
                        <Icon type="md-trash" size='18'/> 删除
                    </Button>
                </div>
            </div>

            <div id="layout-box">
                <div id="box-search">
                    <Form ref="formSearch" :model="searchItems" inline>
                        <FormItem>
                            <Input type="text" v-model="searchItems.name" placeholder="功能项" @keyup.enter.native="initListData(1)" />
                        </FormItem>
                        <FormItem>
                            <Input type="text" v-model="searchItems.code" placeholder="功能项标签" @keyup.enter.native="initListData(1)" />
                        </FormItem>
                        <FormItem>
                            <Button type="primary" @click="initListData(1)">查询</Button>
                        </FormItem>
                    </Form>
                </div>
                <div id="box-table">
                    <Table ref="FunctionList" :columns="tableColumns" :data="functionData" @on-selection-change="functionListSeleChange"></Table>
                </div>
                <div id="page-box">
                    <Page :total="functionCount" :page-size="searchItems.pageSize"
                          @on-change="pageChange" show-total
                          :current="searchItems.pageIndex"
                          style="display:inline-block;">
                    </Page>
                </div>
            </div>

            <Modal v-model="modalDisPlay" draggable sticky scrollable :width="550">
                <p slot="header" style="text-align:left;">
                    <svg class="icon">
                        <use xlink:href="#icon-gongneng2"></use>
                    </svg>
                    <span> 操作功能项</span>
                </p>
                <Form ref="formFunction" :model="formItem" :label-width="70" :rules="ruleFunction">
                    <table style="width:100%;background-color:#fff;padding:20px;border-radius:5px;">
                        <tr>
                            <td>
                                <Form-item label="菜单">
                                    <label style="font-weight:700;font-size:16px;">{{formItem.menuName}}</label>
                                </Form-item>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Form-item label="功能项名" prop="name">
                                    <Input v-model="formItem.name" placeholder="请输入" size="large" />
                                </Form-item>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <Form-item label="功能标签" prop="code">
                                    <Input v-model="formItem.code" placeholder="请输入" size="large" />
                                </Form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <Form-item label="是否启用">
                                    <i-Switch v-model="formItem.isUse" size="large" />
                                </Form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <Form-item label="备注" prop="note">
                                    <Input v-model="formItem.note" type="textarea" placeholder="请输入" size="large" />
                                </Form-item>
                            </td>
                        </tr>
                    </table>
                </Form>

                <div slot="footer">
                    <Button @click="cancel('formFunction')">取消</Button>
                    <Button type="primary" @click="functionSubmit('formFunction')">确定</Button>
                </div>
            </Modal>
        </div>
    </Split>
</template>

<script>
    import request from '@/utils/request'

    export default {
        name: 'functionmanage',
        data() {
            return {
                pageSplit: 0.2,
                treeData:[],
                searchItems: {
                    code: '',
                    name: '',
                    menuName:'',
                    pageSize: 10,
                    pageIndex: 1,
                },
                functionCount: 0,
                modalDisPlay: false,
                tableColumns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '功能项',
                        key: 'name'
                    },
                    {
                        title: '功能项标签',
                        key: 'code'
                    },
                    {
                        title: '是否启用',
                        key: 'isUse',
                        render: (h, params) => {
                            return h('i-Switch', {
                                attrs: {
                                    'value': params.row.isUse
                                },
                                on: {
                                    'on-change': (e) => {
                                        params.row.isUse = e;
                                        let self = this;
                                        request.post('/api/Function/EditUse', params.row).then(function (response) {
                                            if (response.state == 0) {
                                                self.$Notice.error({
                                                    title: '错误提示',duration: 3,
                                                    desc: '更新失败:' + response.errorMsg
                                                });
                                                return;
                                            }
                                            self.$Notice.success({
                                                title: '正确提示',duration: 3,
                                                desc: '更新成功!'
                                            });

                                        }).catch(function (error) {
                                        })
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: '备注',
                        key: 'note'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        align: 'center',
                        fixed: 'right',
                        render: (h, params) => {
                            return [h('i-button', {
                                style: {
                                    'margin-right': '5px'
                                },
                                attrs: {
                                    type: `primary`,
                                    class: "ivu-btn ivu-btn-primary ivu-btn-small"
                                },
                                on: {
                                    click: (e) => {
                                        this.initForm(params.row);
                                        this.modalDisPlay = true;
                                    }
                                },
                            }, "编辑")
                            ];
                        }
                    }
                ],
                functionData: [],
                formItem: {
                    id: 0,
                    code: '',
                    name: '',
                    menuId: 0,
                    menuName: '',
                    path:'',
                    isUse: true,
                    isDele:false,
                    note: '',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                ruleFunction: {
                    name: [
                        { required: true, message: '请填写功能项', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ],
                    code: [
                        { required: true, message: '请填写功能项标签', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ],
                    note: [
                        { type: 'string', max: 100, message: '输入不得大于50个字', trigger: 'blur' }
                    ]
                },
                tableRowIds: [],
                isAdd:false
            }
        },

        methods: {
            initTreeData() {
                let self = this;
                request.get('/api/Menu/GetMenuTree').then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    self.treeData = JSON.parse(response.data);
                    self.initTreeNode(self.treeData);
                }).catch(function (error) {
                })
            },
            initTreeNode(treeData) {
                for (let i = 0; i < treeData.length; i++) {
                    treeData[i].render = (h, { root, node, data }) => {
                        return h('span', [
                            h('svg', {
                                style: {
                                },
                                attrs: {
                                    class: "icon"
                                }
                            }, [h('use', {
                                attrs: {
                                    'xlink:href': `${data.menuIcon}`
                                }
                            })]),
                            h('span', {
                                style: {
                                    cursor: 'pointer',
                                    backgroundColor: node.node.selected ? "#d5e8fc" : "transparent"
                                },
                                attrs: {
                                    class: `ivu-tree-title`
                                },
                                on: {
                                    click: (e) => {
                                        if (!node.node.selected) {
                                            this.$refs.menuTree.handleSelect(node.nodeKey);

                                        }
                                    }
                                }
                            }), data.title]);

                    };
                    if (treeData[i].children && treeData[i].children.length > 0) {
                        this.initTreeNode(treeData[i].children);
                    }
                }
            },
            clickNode() {
                let treeNode = this.$refs.menuTree.getSelectedNodes();
                if (treeNode.length <= 0 || treeNode[0].pId == 0) {
                    return;
                }
                this.formItem.menuId = treeNode[0].value;
                this.formItem.menuName = treeNode[0].title;
                this.searchItems.menuName = treeNode[0].title;
                this.formItem.path = treeNode[0].path;
                if (treeNode[0].children.length > 0) {
                    this.isAdd = false;
                } else {
                    this.isAdd = true;
                }
                this.initListData(1);
            },
            initListData(index) {
                let self = this;
                self.searchItems.pageIndex = index;
                request.post('/api/Function/GetFunctionList', self.searchItems).then(function (response) {
                    if (response.state == 0) {
                        self.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    self.functionData = response.data.function;
                    self.functionCount = response.data.functionCount;
                }).catch(function (error) {
                })
            },
            initForm(data) {
                this.formItem.id = data.id;
                this.formItem.code = data.code;
                this.formItem.name = data.name;
                this.formItem.menuId = data.menuId;
                this.formItem.isUse = data.isUse;
                this.formItem.isDele = data.isDele;
                this.formItem.note = data.note;
                this.formItem.creator = data.creator;
            },
            functionSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let self = this;
                        if (self.formItem.id < 1) {
                            for (var i = 0; i < self.functionData.length; i++) {
                                if (self.functionData[i].code == self.formItem.code) {
                                    this.$Notice.error({
                                        title: '错误提示',duration: 3,
                                        desc: '账号已存在!'
                                    });
                                    return;
                                }

                                if (self.functionData[i].code == self.formItem.code) {
                                    this.$Notice.error({
                                        title: '错误提示',duration: 3,
                                        desc: '功能项标签已存在!'
                                    });
                                    return;
                                }
                            }
                        }

                        request.post('/api/Function/EditFunction', self.formItem).then(function (response) {
                            if (response.state == 0) {
                                self.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: '保存失败:' + response.errorMsg
                                });
                                return;
                            }
                            //清空form规则检查
                            self.modalDisPlay = false;
                            self.initListData(1);
                            self.$Notice.success({
                                title: '正确提示',duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            cancel(name) {
                this.modalDisPlay = false;
                //清空form规则检查
                this.$refs[name].resetFields();
            },
            addFunction() {
                this.modalDisPlay = true;
                this.$refs['formFunction'].resetFields();
                this.formItem.id = 0;
            },
            functionListSeleChange(items) {
                this.tableRowIds = [];
                for (var i = 0; i < items.length; i++) {
                    this.tableRowIds.push(items[i].id);
                }
            },
            deleteFunction() {
                if (this.tableRowIds.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要删除的功能项！'
                    });
                    return;
                }
                let self = this;
                this.$Modal.confirm({
                    title: "操作警告",
                    content: "功能项删除后不可恢复，是否继续操作？",
                    onOk() {
                        request.post('/api/Function/DeleFunction', self.tableRowIds).then(function (response) {

                            if (response.state == 0) {
                                self.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: response.errorMsg
                                });
                                return;
                            }
                            self.initListData(1);
                            self.tableRowIds = [];
                        }).catch(function (error) {
                        })
                    },
                    onCancel() {
                    }
                });
            },
            pageChange(index) {
                this.initListData(index);
            }
        },
        watch: {
        },
        created: function () {
            this.initTreeData();
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    .layout-title {
        overflow: hidden;
        padding: 10px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #box-search {
        padding-top: 20px;
    }

    .layout-title-left {
        float: left;
    }

    .layout-title-right {
        float: right;
    }

    #right-title {
        overflow: hidden;
        padding: 20px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #page-box {
        margin-top: 20px;
        text-align: center;
    }
</style>
